// @flow
import React from 'react'
import { Helmet } from 'react-helmet'
import Layout from '../layout'
import Speakers, { invitedSpeakers } from '../components/speakers'
import styles from './speakers.module.css'

function SpeakersPage() {
  return (
    <Layout>
      <Helmet>
        <title>Speakers</title>
      </Helmet>
      <h1>Speakers</h1>
      <div className={styles.category}>
        <h2>Invited speakers</h2>
        <Speakers includeSpeakers={invitedSpeakers} />
      </div>
      <div className={styles.category}>
        <h2>Authors</h2>
        <Speakers excludeSpeakers={invitedSpeakers} />
      </div>
    </Layout>
  )
}

export default SpeakersPage
